import React from 'react';
import { SERVICES_BASE_ROUTE } from 'src/navigation';
import Services from './pages/Services';
import { RouteObject } from 'react-router-dom';

const Service = React.lazy(() => import('./pages/Service'));
const NewServiceForm = React.lazy(() => import('./register-service-form/pages/NewServiceForm'));

export const NEW_SERVICE_FORM_ROUTE = 'newService';
const FROM_SERVICE_TEMPLATE_ROUTE = 'fromTemplate/';

export const SERVICES = {
  BASE: `${SERVICES_BASE_ROUTE}` as const,
  NEW_SERVICE: `${SERVICES_BASE_ROUTE}/${NEW_SERVICE_FORM_ROUTE}` as const,
  FROM_SERVICE_TEMPLATE:
    `${SERVICES_BASE_ROUTE}/${NEW_SERVICE_FORM_ROUTE}/${FROM_SERVICE_TEMPLATE_ROUTE}` as const,
} as const;

const routes: RouteObject[] = [
  {
    path: '',
    element: <Services />,
    index: true,
  },
  { path: `serviceTemplate/:serviceTemplateId`, element: <Services /> },
  {
    path: `:serviceId`,
    element: <Service />,
  },
  {
    path: `newService/*`,
    element: <NewServiceForm />,
  },
  {
    path: `newService/:serviceId`,
    element: <NewServiceForm />,
  },
  {
    path: `newService/fromTemplate/:templateId`,
    element: <NewServiceForm />,
  },
];

export default routes;
